import { jsx as _jsx } from "react/jsx-runtime";
function SvgComponent() {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "prefix__feather prefix__feather-chevron-down", children: _jsx("path", { d: "M6 9l6 6 6-6" }) }));
}
export default SvgComponent;
